import { memo } from 'react';

interface CompletionPieChartProps {
  percentage: number;
  width?: number;
  height?: number;
  className?: string;
}

export const CompletionPieChart = memo(
  ({ percentage, width = 46, height = 46, className }: CompletionPieChartProps) => {
    const radius = 28;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (percentage / 100) * circumference;

    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 64 65"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <circle
          cx="32"
          cy="32.5"
          r={radius}
          fill="none"
          className="stroke-text-primary-invert"
          strokeOpacity="0.2"
          strokeWidth="7.75676"
        />

        <circle
          cx="32"
          cy="32.5"
          r={radius}
          fill="none"
          className="stroke-text-primary-invert"
          strokeWidth="7.75676"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform="rotate(-90 32 32.5)"
        />

        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="middle"
          className="fill-text-primary-invert text-base font-medium leading-normal tracking-normal"
        >
          {percentage}%
        </text>
      </svg>
    );
  }
);
CompletionPieChart.displayName = 'CompletionPieChart';
